module.exports = __webpack_public_path__ + "static/media/portal_screenshot.7b193324.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/portal_screenshot.png
// module id = 237
// module chunks = 0